import { ChangeDetectorRef, Component, computed, input, Input, OnInit, output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyJsComponent } from './survey-js/survey-js.component';
import { SurveyBuilderComponent } from './survey-builder/survey-builder.component';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { loadStripe } from '@stripe/stripe-js';
import { environment as env } from '@env/environment';
import { concatCommunityAddress, IFileModel, CampaignTypeEnum, ITEM_TYPE_ENUM, ViewParticipateService, IPaymentIntentRequest, IPaymentIntentResponse, ICommunity, DateLevelEnum, AuthStateService, PlatformService, NavigationService, TooltipDirective, CampaignTypeEnumm, TicketDiscountSelectionDto, CampaignSignalService } from '@sml/utility';
import { ItemListingTypeEnum } from '@sml/utility';
import { DialogComponent } from '@sml/dialog';
import { ButtonsModule } from '@sml/buttons';
import { Router } from '@angular/router';
import { AppFormService, FormSubmitDto } from '@sml/utility';
import { SpinnerService } from '@sml/spinner';
import { ToastrService } from '@sml/toastr';
import { SafeUrl } from '@angular/platform-browser';
import { IconsComponent } from '@sml/icons';
import { FormSpinnerService } from '@sml/form-spinner';
import { FORM_DETAIL_STRINGS } from './survey.constant';
import { filter, take } from 'rxjs';

@Component({
  selector: 'lib-survey',
  imports: [CommonModule, SurveyJsComponent, CommonModule, FormsModule, SurveyBuilderComponent, DialogComponent, ButtonsModule, IconsComponent,TooltipDirective],
  templateUrl: './survey.component.html',
  styleUrl: './survey.component.scss',
  standalone: true,
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SurveyComponent implements OnInit {
  @Input() isProposeForm = false;  // Flag to determine if the component is used for Propose form
  @Input() formTitle = '';  // Title for the form
  @Input() formDescription = '';  // Description for the form 
  @Input() isVolunteer = false;  // Description for the form 
  @Input() timeZoneData: any;  // Timezone data for the form
  @Input() isCalledFromItemDrawer=false
  @Input() selectedDiscountGroups: any[] = [];  // Selected discount groups for the form
  profileImage!: IFileModel;
  profileUrl!: SafeUrl;
  campaignTypeEnums=CampaignTypeEnum

  public communityAddress = '';
  private _communityData: ICommunity | undefined;
  isShowPaymentLoader = false;

  @Input()
  set communityData(value: any) {
    this._communityData = value;
    this.communityAddress = concatCommunityAddress(this.communityData);
    this.proposeFormId = this.communityData?.formMasterId || null;
    this.communityId = this.communityData?.id || null;
    if (this.communityData?.profileImageBlob) {
      this.profileImage = JSON.parse(this.communityData.profileImageBlob)[0];
      this.profileUrl = this.profileImage.BlobUrl;
    }
  }

  get communityData(): any {
    return this._communityData;
  }

  @Input() isFromParticipateNow = false;
  @Input() previewFormData: any = {};
  stripe: any;
  elements: any;
  card: any;
  bankAccount: any;
  fullName = '';
  email = '';
  phone = '';
  postalCode = '';
  amount!: number;  // Example amount
  selectedPaymentMethod: string | null = null;  // Default to bank transfer
  @ViewChild(SurveyJsComponent) surveyComponent!: SurveyJsComponent;
  closeParticipateModal = output();
  itemData = input<any | null>(null);
  selectedShift = input<any | null>(null);
  customItemPrice = input<number | null>(null);
  /** Ticket quantity from story-item (Enter Ticket QTY); displayed read-only in Survey */
  ticketQuantity = input<number | null>(null);
  /** Quantity for ticket type: ticketQuantity (mandatory), clamped >= 1. */
  effectiveTicketQuantity = computed(() => {
    return this.ticketQuantity();
  });
  /**
   * For Ticket: price = item price × ticket quantity. When discount groups are selected,
   * the combined total (Σ price × qty) is passed via customItemPrice and used directly.
   * Returns 0 when quantity not set.
   */
  ticketTotalPrice = computed(() => {
    if (this.customItemPrice() != null) {
      return this.customItemPrice() ?? 0;
    }
    const qty = this.effectiveTicketQuantity();
    return qty != null ? qty * (this.itemData()?.price ?? 0) : 0;
  });
  /** Max number of discount-group chips shown before collapsing the rest into "...". */
  readonly MAX_VISIBLE_DISCOUNT_CHIPS = 5;
  /** Per-chip title character budget; longer titles are truncated with an ellipsis. */
  readonly DESKTOP_CHIP_TITLE_LIMIT = 22;
  readonly MOBILE_CHIP_TITLE_LIMIT = 20;

  /** First 5 selected discount groups, kept in selection order. */
  get visibleDiscountGroups(): any[] {
    return (this.selectedDiscountGroups ?? []).slice(0, this.MAX_VISIBLE_DISCOUNT_CHIPS);
  }
  /** Groups beyond the first 5, collapsed into the "..." chip. */
  get hiddenDiscountGroups(): any[] {
    return (this.selectedDiscountGroups ?? []).slice(this.MAX_VISIBLE_DISCOUNT_CHIPS);
  }
  /** Truncates a chip title to the given character limit, appending an ellipsis when clipped. */
  truncateTitle(title: string, limit: number): string {
    const value = title ?? '';
    return value.length > limit ? `${value.slice(0, limit)}…` : value;
  }
  /** Whether the title exceeds the limit (so a tooltip with the full title should show). */
  isTitleTruncated(title: string, limit: number): boolean {
    return (title?.length ?? 0) > limit;
  }
  /** Builds the tooltip markup listing the collapsed discount groups. */
  getDiscountGroupsTooltip(groups: any[]): string {
    return (groups ?? []).map((g) => `${g?.quantity} × ${g?.title}`).join('<br>');
  }

  proposeFormId: number | null = null;
  communityId: number | null = null;
  itemTypeEnum = ITEM_TYPE_ENUM;
  formDetailStrings = FORM_DETAIL_STRINGS;
  @ViewChild('smlCancelSurveyModal') smlCancelSurveyModal!: DialogComponent;
  showCancelSurveyDialog: boolean = false;
  proposeFormDescription: string = 'Please fill out the form below if you’d like to donate, volunteer, or give back in a new way.';
  isGooglePayAvailable = false;
  paymentIntentResponse!: IPaymentIntentResponse;
  paymentRequest: any;
  googlePayButton: any;
  campaignTypeEnum = CampaignTypeEnumm;
  isOverView = false;
  isParticipateForm: boolean = false;
  isMobileView = false;
  dateEnum = DateLevelEnum;
  achElement: any;
  public isLoggedIn = false;

  constructor(private readonly toaster: ToastrService, private readonly cdr: ChangeDetectorRef, private readonly platformService: PlatformService,
    private readonly authState: AuthStateService, private http: HttpClient, private router: Router, private participateService: ViewParticipateService,
    private appFormService: AppFormService, private readonly spinnerService: SpinnerService, private formSpinnerService: FormSpinnerService,
    private readonly navagationService: NavigationService, private readonly campaignSignalService: CampaignSignalService
  ) {
    if (this.platformService.browser()) {
      this.authState.auth.isAuthenticated$.subscribe(isAuthenticated => {
        this.isLoggedIn = isAuthenticated;
      })
    };
  }

  async ngOnInit() {
    this.setIsOverView();
    this.isParticipateForm = this.router.url.includes('/overview') || this.router.url.includes('/gallery') || this.router.url.includes('/map') || this.router.url.includes('/preview');
    this.isMobileView = window.innerWidth < 768;
    // Load Stripe.js with your publishable key
    console.log(this.itemData());
    if (this.itemData().isAcceptPaymentOnline && !this.itemData()?.requireApplicantApproval) {
      this.stripe = await loadStripe(env.stripePublishableKey);  // Replace with your actual Stripe publishable key
      this.paymentRequest = this.stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'Total',
          amount: (this.itemData()?.typeId === this.itemTypeEnum['Ticket']
            ? this.ticketTotalPrice()
            : (this.itemData().itemListingType === ItemListingTypeEnum.Custom ? this.customItemPrice() : this.itemData().price)) * 100, // Convert to cents
        },
      });
      const result = await this.paymentRequest.canMakePayment();
      this.isGooglePayAvailable = !!result?.googlePay;
      this.spinnerService.hideSpinner();
    }
  }

  private setIsOverView() {
    this.isOverView = this.router.url.includes('/overview') || this.router.url.includes('/gallery') || this.router.url.includes('/map')
      || this.router.url.includes('/custom-grid') || this.router.url.includes('/custom-form-builder')
      || this.router.url.includes('/custom-template-form-builder') || this.router.url.includes('/custom-template-grid')
      || this.router.url.includes('/item/add') || this.router.url.includes('/item/update')
      || this.router.url.includes('/create') || this.router.url.includes('/map') || this.router.url.includes('/preview');
  }

  onClose() {
    this.closeParticipateModal.emit();
  }

  isEmpty(obj: any): boolean {
    return !obj || Object.keys(obj).length === 0;
  }

  onCloseForm() {
    const isNonLoggedInParticipate = this.router.url.includes('/preview');
    if ((this.isParticipateForm || this.isProposeForm || (!this.isLoggedIn && isNonLoggedInParticipate)) && !this.isCalledFromItemDrawer) {
      this.participateService.showParticipateConfPopup(true);
      return;
    }
    this.closeParticipateModal.emit();
  }

  paymentMethodHandler: any;

  resetPaymentMethod() {
    this.selectedPaymentMethod = null; // Reset the selected payment method
    this.cdr.detectChanges(); // Trigger change detection to update the view
  }

  isPaymentIntentLoaded = false
  onPaymentMethodChange(method: string) {
    this.isPaymentIntentLoaded = false;
    const isError = this.surveyComponent.isFormInvalid(); // Validate the form before submission
    if (isError) {
      this.showFormError(); 
      setTimeout(() => {
        this.selectedPaymentMethod = '';
      }, 0);
      return;
    }
    const firstName = this.surveyComponent.getFormValue('FirstName') || '';
    const lastName = this.surveyComponent.getFormValue('LastName') || '';
    this.fullName = `${firstName} ${lastName}`;
    this.email = this.surveyComponent.getFormValue('Email') || '';
    this.phone = this.surveyComponent.getFormValue('Phone') || '';
    this.postalCode = this.surveyComponent.getFormValue('ZipCode') || '';
    try {
      const paymentIntentRequest: IPaymentIntentRequest = {
        amount: (this.itemData()?.typeId === this.itemTypeEnum['Ticket']
          ? this.ticketTotalPrice()
          : (this.itemData().itemListingType === ItemListingTypeEnum.Custom ? this.customItemPrice() : this.itemData().price)) * 100, // Convert to cents
        email: this.email,
        name: this.fullName,
        phone: this.phone,
        postalCode: this.postalCode,
        paymentMethod: this.selectedPaymentMethod === 'gpay' ? 'card' : this.selectedPaymentMethod, // Use 'card' for Google Pay
        metaData: {
          "ItemId": this.itemData().itemId ?? '',
          "Quantity": this.itemData()?.typeId === this.itemTypeEnum['Ticket']
            ? (this.effectiveTicketQuantity() != null ? String(this.effectiveTicketQuantity()) : '')
            : (this.itemData().quantity ? String(this.itemData().quantity) : ''),
          "RemainingQuantity": this.itemData().remainingQuantity ? String(this.itemData().remainingQuantity) : '',
          "PaymentMethod": this.selectedPaymentMethod ?? '',
          "IPAddress": this.navagationService.ipAddress || '',
        },
      descriptor: this.itemData()?.descriptor ?? undefined,
      donorId: null
      }

      if (this.itemData()?.isAcceptPaymentOnline && !this.itemData()?.requireApplicantApproval) {
        // Include current form values in the create-payment-intent call so backend can persist them
        const currentFormValues = this.surveyComponent?.getSurveyDataSnapshot?.() ?? {};
        const formSubmitDtoPayload = {
          itemId: this.itemData()?.id,
          communityId: this.itemData()?.communityId ?? this.communityId,
          isOnlinePayment: !!this.itemData()?.isAcceptPaymentOnline,
          formValues: currentFormValues,
          formId: this.itemData().formMasterId ?? this.proposeFormId,
          isVolunteer:
            this.itemData()?.campaignTypeId ===
            CampaignTypeEnum['Volunteer Activity'],
          volunteerShiftId: this.selectedShift()?.id,
          paymentMethod:
            this.itemData()?.isAcceptPaymentOnline && this.selectedPaymentMethod
              ? this.selectedPaymentMethod === 'bank'
                ? 54
                : 53
              : undefined,
          price: this.itemData()?.isAcceptPaymentOnline
            ? (this.itemData()?.typeId === this.itemTypeEnum['Ticket']
                ? this.ticketTotalPrice()
                : (this.itemData().itemListingType === ItemListingTypeEnum.Custom ? this.customItemPrice() : this.itemData().price))
            : undefined,
          numberOfTickets: this.itemData()?.typeId === this.itemTypeEnum['Ticket'] ? this.effectiveTicketQuantity() : null,
          requireApplicantApproval: this.itemData()?.requireApplicantApproval ?? false,
            discountSelections: this.convertSelectedGroupToDto(this.selectedDiscountGroups),
        };
        paymentIntentRequest.formSubmitDtoJson = JSON.stringify(formSubmitDtoPayload);
      }
      
      this.appFormService.getPaymentIntent(paymentIntentRequest).subscribe({
        next: response => {
          if (response) {
            this.paymentIntentResponse = response;
          } else {
            console.error('Failed to receive clientSecret from the backend.');
            return;
          }

          this.elements = this.stripe.elements({ clientSecret: this.paymentIntentResponse.clientSecret });

          if (this.selectedPaymentMethod === 'gpay') {
            this.paymentRequest.off('paymentmethod', this.paymentMethodHandler);
            this.paymentMethodHandler = async (ev: any) => {
              const clientSecret = this.paymentIntentResponse.clientSecret;
              try {
                // Step 1: Confirm the payment with Stripe
                const { error, paymentIntent } = await this.stripe.confirmCardPayment(
                  clientSecret,
                  { payment_method: ev.paymentMethod.id },
                  { handleActions: false }
                );
                if (error) {
                  // If there's an error, fail the flow and show message
                  ev.complete('fail');
                  this.toaster.error({ message: error?.message ?? 'Unknown Error', title: "Payment Failed" });
                  console.error(`Error: ${error.message}`);  // Log error instead of alert
                  return;
                }
                // **Immediately complete the Google Pay flow as soon as payment succeeds**
                if (paymentIntent.status === 'succeeded') {
                  ev.complete('success');  // Immediately complete Google Pay UI
                  setTimeout(async () => {
                    console.log('Payment successful!');  // Log success
                    this.formSpinnerService.showFormSpinner({ isPayment: true });
                    this.participateService.hideParticipate();
                    this.surveyComponent.completeSurvey();
                    console.log('API call complete');
                  }, 0);
                } else if (paymentIntent.status === 'requires_action') {
                  const { error: retryError, paymentIntent: finalPaymentIntent } = await this.stripe.confirmCardPayment(clientSecret);
                  if (retryError) {
                    ev.complete('fail');
                    this.toaster.error({ message: retryError?.message ?? 'Unknown Error', title: "Payment Failed" });
                    console.error(`Retry Error: ${retryError.message}`);
                    return;
                  }

                  if (finalPaymentIntent.status === 'succeeded') {
                    ev.complete('success'); 
                    setTimeout(async () => {
                      console.log('Payment successful after retry!');
                      this.formSpinnerService.showFormSpinner({ isPayment: true });
                      this.participateService.hideParticipate();
                      this.surveyComponent.completeSurvey();
                      console.log('API call complete');
                    }, 0);
                  } else {
                    ev.complete('fail');
                    this.toaster.error({ message: finalPaymentIntent.status ?? 'Unknown Error', title: "Payment Failed" });
                    console.error('Payment failed after retry.');
                  }
                } else {
                  ev.complete('fail');
                  this.toaster.error({ message: paymentIntent.status ?? 'Unknown Error', title: "Payment Failed" });
                  console.error(`Unexpected payment status: ${paymentIntent.status}`);
                }
              } catch (error) {
                ev.complete('fail');
                this.toaster.error({ message: 'Unknown Error', title: "Payment Failed" });
                console.error(`Error during payment flow: ${error}`);
              }
            }
            this.paymentRequest.on('paymentmethod', this.paymentMethodHandler);
          }
          this.googlePayButton = this.elements.create('paymentRequestButton', {
            paymentRequest: this.paymentRequest,
          });
          this.card = this.elements.create('card');
          this.bankAccount = this.elements.create('payment', {
            fields: {
              billingDetails: {
                name: 'never',
                email: 'never', // This hides the email field
              },
            },
            paymentMethodOrder: ['us_bank_account'],
          });
          this.mountElement(this.selectedPaymentMethod || '');
        },
        error: error => {
          console.error('API error:', error);
        }
      });
    } catch (error) {
      console.error('API error:', error);
    }
  }

  // Mount the selected Stripe Element based on the selected payment method
  mountElement(paymentMethod: string) {
    // Unmount the previously mounted element
    if (this.card && this.card.isMounted) {
      this.card.unmount();
    }
    if (this.bankAccount && this.bankAccount.isMounted) {
      this.bankAccount.unmount();
    }
    if (this.googlePayButton && this.googlePayButton.isMounted) {
      this.googlePayButton.unmount();
    }
    // Mount the selected element
    if (paymentMethod === 'card') {
      this.card.mount('#card-element');
      this.isPaymentIntentLoaded = true;
    } else if (paymentMethod === 'bank') {
      this.bankAccount.mount('#bank-account-element');
      this.isPaymentIntentLoaded = true;
    } else if (paymentMethod === 'gpay') {
      this.paymentRequest.canMakePayment().then((result: any) => {
        if (result) {
          this.googlePayButton.mount('#google-pay-button');
          this.isPaymentIntentLoaded = true;
        } else {
          alert(`Google Pay is not available: ${JSON.stringify(result)}`);
          console.log('Google Pay is not available');
        }
      });
    }
  }

  get hasFormErrors(): boolean {
    return this.surveyComponent.hasFormErrors;
  }

  /** True when this submission takes an online payment now (vs a plain form submit). */
  private get isPaymentSubmission(): boolean {
    return !!(this.itemData()?.isAcceptPaymentOnline && !this.itemData()?.requireApplicantApproval);
  }

  /** Number of payment method tiles shown — drives the tile grid columns. */
  get paymentTileCount(): number {
    const isTicketing = this.itemData()?.campaignTypeId === this.campaignTypeEnum['Ticketing'];
    let count = 1; // Card is always available
    if (!isTicketing) count++; // US bank account (hidden for ticketing)
    if (this.isGooglePayAvailable) count++; // Google Pay
    return count;
  }

  async handleSubmit(event: Event) {
    const isError = this.surveyComponent.isFormInvalid();
    if (isError) {
      this.showFormError();
      return;
    }
    if (this.itemData()?.isAcceptPaymentOnline && !this.itemData()?.requireApplicantApproval) {
      if(this.isPaymentIntentLoaded){
        this.isShowPaymentLoader = true;
        this.formSpinnerService.showFormSpinner({ isPayment: true });
      }
      if (!this.isPaymentIntentLoaded) {
        this.formSpinnerService.hideFormSpinner();
        this.toaster.error({ message: 'Payment initialization failed. Please try again.', title: "Payment Failed" });
        console.error('Payment initialization failed: Missing clientSecret');
        return;
      }
      // Step 1: Confirm the payment using Stripe.js
      const { error, paymentIntent } = this.selectedPaymentMethod === 'card'
        ? await this.confirmCardPayment(this.paymentIntentResponse.clientSecret)
        : this.selectedPaymentMethod === 'bank' ? await this.confirmPayment(this.paymentIntentResponse.clientSecret)
          : { error: { message: 'Unsupported payment method' } };

      if (!this.selectedPaymentMethod) {
        this.isShowPaymentLoader = false;
        this.formSpinnerService.hideFormSpinner();
        this.toaster.error({ message: `Please select a Payment Method for your submission.`, title: "Payment method not selected" });
        return;
      }
      else if (error) {
        this.isShowPaymentLoader = false;
        this.formSpinnerService.hideFormSpinner();
        this.toaster.error({ message: error?.message ?? 'Unknown Error', title: "Payment Failed" });
        console.error('Payment error:', error);
      }
      else if (
        (this.selectedPaymentMethod === 'bank' && 
          (paymentIntent.status === 'processing' || paymentIntent.status === 'requires_action')) ||
        (this.selectedPaymentMethod === 'card' && paymentIntent.status === 'succeeded')
      ) {
        this.isShowPaymentLoader = false;
        this.participateService.hideParticipate();
        this.formSpinnerService.showSuccess({ title: 'Payment Complete!' });
        this.refreshCampaignAfterParticipation();
      }
      else {
        this.formSpinnerService.hideFormSpinner();
        const failedObj = {
          message: 'Payment failed and requires additional action.',
          paymentStatus: paymentIntent.status,
          paymentMethod: this.selectedPaymentMethod
        }
        this.toaster.error({ message: JSON.stringify(failedObj), title: "Payment Failed" });
        console.error('Payment failed:', failedObj);
      }
    }
    else {
      this.formSpinnerService.showFormSpinner({ isPayment: false });
      this.surveyComponent.completeSurvey();
    }
  }

  private async confirmCardPayment(clientSecret: string) {
    return await this.stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: this.card,
        billing_details: {
          name: this.fullName, // You can fetch this dynamically from your form
          email: this.email,
          phone: this.phone,
          address: {
            postal_code: this.postalCode,
          }
        }
      }
    });
  }


  private async confirmPayment(clientSecret: string) {
    return await this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: {
        payment_method_data: {
          billing_details: {
            name: this.fullName,
            email: this.email,
            phone: this.phone,
            address: {
              postal_code: this.postalCode,
            }
          }
        }
      },
      redirect: 'if_required'
    });
  }


  onSurveyDataReceived(data: any): void {
    this.formSpinnerService.showFormSpinner({ isPayment: this.isPaymentSubmission });
    if (this.isProposeForm) {
      this.participateService.hideParticipate();
    }
    if (this.itemData()?.isAcceptPaymentOnline && !this.itemData()?.requireApplicantApproval) {
      setTimeout(() => {
        this.formSpinnerService.showSuccess({ title: 'Payment Complete!' });
        this.refreshCampaignAfterParticipation();
      }, 1000);
    }
    else
    {
    // Optionally send to backend
    const formsubmit: FormSubmitDto = {
      itemId: this.itemData()?.id, // Assuming you have an item ID, otherwise set to 0 or undefined
      communityId: this.itemData()?.communityId ?? this.communityId, // Replace with actual community ID
      isOnlinePayment: !!this.itemData()?.isAcceptPaymentOnline,
      formValues: data,
      formId: this.itemData().formMasterId ?? this.proposeFormId,
      paymentMethod: (this.itemData()?.isAcceptPaymentOnline && this.selectedPaymentMethod) ?
        this.selectedPaymentMethod === 'bank' ? 54 : 53
        : undefined,
      price: this.itemData()?.isAcceptPaymentOnline ?
        (this.itemData()?.typeId === this.itemTypeEnum['Ticket'] ? this.ticketTotalPrice() : (this.itemData().itemListingType === ItemListingTypeEnum.Custom ? this.customItemPrice() : this.itemData().price))
        : undefined,
      numberOfTickets: this.itemData()?.typeId === this.itemTypeEnum['Ticket'] ? this.effectiveTicketQuantity() : null,
      isVolunteer: this.itemData()?.campaignTypeId === CampaignTypeEnum['Volunteer Activity'],
      paymentIntentId: this.paymentIntentResponse?.id,
      volunteerShiftId: this.selectedShift()?.id,
      requireApplicantApproval: this.itemData()?.requireApplicantApproval ?? false,
      discountSelections: this.convertSelectedGroupToDto(this.selectedDiscountGroups)
    };
    this.participateService.hideParticipate();
      this.formSpinnerService.showFormSpinner({ isPayment: false });
    this.appFormService.submitForm(formsubmit).subscribe({
      next: () => {
        const header = this.itemData()?.isAcceptPaymentOnline&& !this.itemData()?.requireApplicantApproval  ? 'Payment Complete!' : 'Form Complete!';
        this.formSpinnerService.showSuccess({ title: header });
        this.refreshCampaignAfterParticipation();
      },

      error: (error) => {
        this.formSpinnerService.showError();
        this.toaster.error({ message: `Some error occurred during saving the form: ${JSON.stringify(error)}`, title: "Error saving form " });
        console.error('Some error occurred during saving the form', error);
      }
    });
    }
  }

  /**
   * Lets the screen behind the overlay reload its totals and lists: once now,
   * and again when the success popup is closed, because the server may still
   * be recording the participation when the first reload lands.
   */
  private refreshCampaignAfterParticipation(): void {
    this.campaignSignalService.triggerRefresh();
    this.formSpinnerService.getFormSpinnerState()
      .pipe(filter(state => state.mode === 'hidden'), take(1))
      .subscribe(() => this.campaignSignalService.triggerRefresh());
  }

  isValidFilesSize = true;
  onIsValidFilesSize(isValidFilesSize: boolean): void {
    this.isValidFilesSize = isValidFilesSize;
    if (!isValidFilesSize) {
      this.selectedPaymentMethod = null;
      this.toaster.error({ message: 'The total file size exceeds the 20 MB upload limit. Please remove some files and try again.', title: 'File upload size exceeded' });
    }
  }

  invalidExtensionMessage = '';
  onSurveyFileExtnValidation(invalidExtensionMessage: string): void {
    this.invalidExtensionMessage = invalidExtensionMessage;
    if (invalidExtensionMessage) {
      this.selectedPaymentMethod = null;
      this.toaster.error({ message: invalidExtensionMessage, title: "Unsupported file format" });
    }
  }

  invalidExtensionMessageCombined = '';
  onSurveyFileExtnValidationCombined(invalidExtensionMessageCombined: string): void {
    this.invalidExtensionMessageCombined = invalidExtensionMessageCombined;
  }

  isFormValid = false;
  onIsFormValid(isValid: boolean): void {
    this.isFormValid = isValid;
    if (!isValid) {
      this.showFormError();
    }
  }
  private convertSelectedGroupToDto(selectedGroups: any[]): TicketDiscountSelectionDto[] {
    return selectedGroups.map(group => ({
      discountGroupId: group.id,
      isFreeTicket: group.isFreeTicket,
      title: group.title,
      price: group.price,
      quantity: group.quantity
    }));
  }

  private showFormError() {
    this.selectedPaymentMethod = null;
    if (!this.isValidFilesSize) {
      this.toaster.error({ message: 'The total file size exceeds the 20 MB upload limit. Please remove some files and try again.', title: 'File upload size exceeded' });
    }
    else if (this.invalidExtensionMessageCombined) {
      this.toaster.error({ message: this.invalidExtensionMessageCombined, title: 'Unsupported file format' });
    }
    else {
      this.toaster.error({ message: 'There are errors in this form. Please correct them before moving on.', title: "Error in form " });
    }
  }

  onCloseFormDialog(): void {
    this.smlCancelSurveyModal.closeModal();
    this.showCancelSurveyDialog = false;
  }

  onClosePopup() {
    this.showCancelSurveyDialog = false;
  }

  onConfirmCloseFormDialog() {
    this.closeParticipateModal.emit();
    this.smlCancelSurveyModal.closeModal();
    this.showCancelSurveyDialog = false;
  }

  getDefaultImage(campaignTypeId?: number | null): string {
    if (campaignTypeId === CampaignTypeEnumm['Ticketing']) {
      const item = this.itemData();
      if (item?.featureImage) {
        return item.featureImage;
      }
      if (item?.blobUrls) {
          const arr = JSON.parse(item.blobUrls) as { BlobUrl?: string }[];
          if (arr?.length && arr[0]?.BlobUrl) {
            return arr[0].BlobUrl;
          }     
      }
      return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Ticketing%20-%20Default%20Image.jpg';
    }
    switch (campaignTypeId) {
      case this.campaignTypeEnums['Volunteer Activity']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Volunteer%20-%20Default%20Image.jpg';
      case this.campaignTypeEnums['Memorial Program']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Memorial%20Item%20-%20Default%20Image.jpg';
      case this.campaignTypeEnums['Sponsorship + Fundraiser']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Sponsorship%20Fundraiser%20-%20Default%20Image.jpg';
      case this.campaignTypeEnums.Other:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Community%20Initiative%20-%20Default%20Image.jpg';
      case CampaignTypeEnumm['Sponsorship']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Sponsorship%20Default%20Image.jpeg';
      case CampaignTypeEnumm['Fundraiser']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Fundraiser%20-%20Default%20Image.jpg';
      case CampaignTypeEnumm['Registration']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Registration%20Default%20Image.jpeg';
      case CampaignTypeEnumm['Interactive Tour']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Interactive%20Tour%20-%20Default%20Image.jpg';
      default:
        return './assets/images/placeholder.png';
    }
  }
}
